module.exports = __webpack_public_path__ + "f9230937dced94a0093d33c923f99dc3.pdf";